const theme = {
  colors: {
    base: "#fefcfc",
    primary: "#1485c7",
    varPrimary: "#66b7df",
    variation: "#E0F1F9",
    auxiliar: "#0b0a0a",
    gray: "#D9D9D9",
    grayLight: "#A0A8AD",
    grayDark: "#7D7D7D",
  },
  headings: {
    h1: {
      fontSize: "40px",
      fontWeight: 700,
      fontFamily: "Open sans",
    },
    h2: {
      fontSize: "32px",
      fontWeight: 600,
      fontFamily: "Open sans",
    },
    h3: {
      fontSize: "24px",
      fontWeight: 700,
      fontFamily: "Open sans",
    },
    h4: {
      fontSize: "16px",
      fontWeight: 700,
      fontFamily: "Open sans",
    },
    h1Mobile: {
      fontSize: "22px",
      fontWeight: 700,
      fontFamily: "Open sans",
    },
    h2Mobile: {
      fontSize: "20px",
      fontWeight: 600,
      fontFamily: "Open sans",
    },
    h3Mobile: {
      fontSize: "18px",
      fontWeight: 600,
      fontFamily: "Open sans",
    },
    h4Mobile: {
      fontSize: "16px",
      fontWeight: 600,
      fontFamily: "Open sans",
    },
  },
  buttons: {
    primary: {
      border: "1px solid #1485c7",
      background: "#1485c7",
      color: "#fefcfc",
      hover: {
        border: "1px solid #1485c7",
        background: "#fefcfc",
        color: "#1485c7",
      },
    },
    secondary: {
      border: "1px solid #66b7df",
      background: "#fefcfc",
      color: "#66b7df",
      hover: {
        border: "1px solid #66b7df",
        background: "#66b7df",
        color: "#fefcfc",
      },
    },
    primaryMobile: {
      border: "1px solid #A0A8AD",
      background: "#A0A8AD",
      color: "#fefcfc",
      hover: {
        border: "1px solid #A0A8AD",
        background: "#fefcfc",
        color: "#A0A8AD",
      },
    },
    secondaryMobile: {
      border: "1px solid #7D7D7D",
      background: "#7D7D7D",
      color: "#fefcfc",
      hover: {
        border: "1px solid #7D7D7D",
        background: "#fefcfc",
        color: "#7D7D7D",
      },
    },
  },
  fontButtons: {
    big: {
      fontSize: "24px",
      fontWeight: 600,
      fontFamily: "Open sans",
    },
    medium: {
      fontSize: "32px",
      fontWeight: 600,
      fontFamily: "Open sans",
    },
    small: {
      fontSize: "22px",
      fontWeight: 600,
      fontFamily: "Open sans",
    },
    bigMobile: {
      fontSize: "18px",
      fontWeight: 700,
      fontFamily: "Open sans",
    },
    mediumMobile: {
      fontSize: "16px",
      fontWeight: 700,
      fontFamily: "Open sans",
    },
    smallMobile: {
      fontSize: "14px",
      fontWeight: 600,
      fontFamily: "Open sans",
    },
  },
  paragraphs: {
    P: {
      fontSize: "24px",
      fontWeight: 400,
      fontFamily: "Open sans",
    },
    P2: {
      fontSize: "20px",
      fontWeight: 600,
      fontFamily: "Open sans",
    },
    P3: {
      fontSize: "14px",
      fontWeight: 600,
      fontFamily: "Open sans",
    },
    PMobile: {
      fontSize: "18px",
      fontWeight: 400,
      fontFamily: "Open sans",
    },
    P2Mobile: {
      fontSize: "16px",
      fontWeight: 400,
      fontFamily: "Open sans",
    },
    P3Mobile: {
      fontSize: "12px",
      fontWeight: 400,
      fontFamily: "Open sans",
    },
  },
};

export { theme };
